import {Animated, TouchableOpacity, View} from 'react-native';
import * as React from 'react';
import {useRef} from 'react';

import {IStateProps} from './model';
import {SnackbarNotificationType} from '../../model';
import {images} from '../../../../../assets/icons';
import {Text} from '../../../text';
import {ExclamationInCircle} from '../../../explamationInCircle';
import {useTheme} from '../../../../theme';
import {GetStyles} from './style';

type NotificationIconProps = {
  type: SnackbarNotificationType;
};

const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const theme = useTheme();
  const color = theme.snackbar.colors[props.type].backgroundColor;
  const bgColor = theme.color.whiteTextColor;
  switch (props.type) {
    case SnackbarNotificationType.Success: {
      return <images.CheckInCircle color={bgColor} width={16} height={16} />;
    }
    case SnackbarNotificationType.Warning: {
      return <images.QuestionInTriangle color={color} width={16} height={16} />;
    }
    case SnackbarNotificationType.Error: {
      return <ExclamationInCircle color={color} backgroundColor={bgColor} size={16} />;
    }
    default: {
      return <ExclamationInCircle color={color} backgroundColor={bgColor} size={16} />;
    }
  }
};

export default ({notification, onPressClose, onHideAnimationEnd, hideAnimationStart}: IStateProps) => {
  const moveDown = useRef(new Animated.Value(0)).current;
  const opacity = useRef(new Animated.Value(1)).current;
  const styles = GetStyles(notification);
  React.useEffect(() => {
    Animated.timing(moveDown, {
      useNativeDriver: true,
      toValue: 1,
      duration: 300,
      easing: (v) => v,
    }).start();
  }, []);
  React.useEffect(() => {
    if (hideAnimationStart) {
      Animated.timing(opacity, {
        useNativeDriver: true,
        toValue: 0,
        duration: 1000,
        easing: (v) => v,
      }).start((result) => {
        if (result.finished) {
          onHideAnimationEnd();
        }
      });
    }
  }, [hideAnimationStart]);

  const translateY = moveDown.interpolate({
    inputRange: [0, 1],
    outputRange: [-100, 0],
  });

  return (
    <Animated.View
      testID={`snackbar-notification-${notification.type}-id`}
      nativeID='notification_blank'
      style={{
        ...{
          pointerEvents: 'auto',
          transform: [
            {
              translateY: translateY,
            },
          ],
          opacity,
        },
      }}>
      <View style={[styles.container, styles['container' + notification.type]]}>
        <View style={styles.iconWrapper}>
          <NotificationIcon type={notification.type} />
        </View>
        <View style={styles.message}>
          <Text testID={`snackbar-notification-${notification.type}-text-id`} style={styles.messageText}>
            {notification.message}
          </Text>
        </View>
        <TouchableOpacity
          testID={`snackbar-notification-${notification.type}-close-id`}
          onPress={onPressClose}
          style={styles.close}>
          <Text style={styles.actionIcon}>
            <images.Close width={16} height={16} color={styles.actionIcon.color} />
          </Text>
        </TouchableOpacity>
      </View>
    </Animated.View>
  );
};
